<template>
  <div class="home_header_box">
    <!-- 顶部 -->
    <div class="header">
      <div class="box">
        <div class="icon" @click="">
          <img src="../../assets/images/home/home10.png" alt="" />
          <!-- <span>万康人体解剖</span> -->
        </div>
        <div class="table">
          <span @click="changeView(1)">首页
            <div v-show="isHome == 1"></div>
          </span>
          <span @click="changeView(2)">网页版
            <div v-show="isHome == 2"></div>
          </span>
        </div>
        <img v-if="!user.access_token" class="no_vip" src="../../assets/images/home/home22.png" alt="" @click="login" />
        <div class="login" @click="login" v-if="!user.access_token">登录</div>
        <div class="user" v-if="user.access_token" @mouseleave="quitmouseleave">
          <img class="no_vip" v-if="user.vip_type == 0" src="../../assets/images/home/home22.png" alt=""
            @click="goPersonal(1)" />
          <span>{{ user.nickname }}</span>
          <img class="avatar" :src="user.avatar ? user.avatar : require('../../assets/images/home/home15.png')
            " @mouseenter="avatarcli" alt="" />
          <!-- isQuit -->
          <div class="quit" v-show="isQuit" @mouseleave="quitmouseleave">
            <div class="trans"></div>
            <!-- 没会员 -->
            <div class="vip_info" v-if="user.vip_type == 0">
              <div>购买会员，解锁所有模型</div>
              <div>开通会员·尊享12项万康人体解剖权益</div>
              <div @click="goPersonal(3)">立即升级会员</div>
            </div>
            <!-- 有会员 -->
            <div class="vip_info_have" v-if="user.vip_type != 0" @click="goPersonal(3)">
              <div class="left">
                <img src="../../assets/images/vip/vip28.png" alt="" />
              </div>
              <div class="right">
                <div class="vip_name">{{ vipnameHandle(user.vip_type) }}</div>
                <div class="vip_time" v-if="user.vip_type != 6">
                  到期时间：{{ viptimeHandle(user.vip_expire) }}
                </div>
              </div>
            </div>
            <div class="btn">
              <div class="left" @click="goPersonal(2)">
                <img src="../../assets/images/home/home20.png" alt="" />
                <span>收藏中心</span>
              </div>
              <div class="right" @click="quitLogin">
                <img src="../../assets/images/home/home21.png" alt="" />
                <span>退出登录</span>
              </div>
            </div>
          </div>
          <img class="vip" v-if="user.vip_type != 0" src="../../assets/images/home/home18.png" alt="" />
        </div>
      </div>
    </div>
    <!-- 会员购买弹框 -->
    <div class="mask" v-if="isVipPay">
      <vipPopFrame @close="close" @click.stop></vipPopFrame>
    </div>
  </div>
</template>

<script>
import { h } from "vue";
import aes from "@/utils/AES";
import Api from "@/api/api";
import { mapState } from "vuex"; // 调用辅助函数用于监听
import vipPopFrame from "../../components/vipPopFrame/vipPopFrame.vue";
export default {
  props: {
    someProp: {
      type: Number, // 或者其他类型，比如 Number, Object, Array 等
      required: false, // 根据需要设置是否为必传
    },
  },
  data() {
    return {
      user: {}, // 用户信息
      code: null, // 获取的code
      loginMessage: "", // 登录信息
      detailIndex: null,
      id: 99,
      isQuit: false, // 退出弹框打开
      isHome: 1, // 1.首页 2.模型网页版
      abilityCome: 1, // 用于监听是否从网页版跳转到支付页面
      isVipPay: false,
    };
  },
  created() { },
  computed: {
    ...mapState(["pageNum"]),
  },
  components: {
    vipPopFrame,
  },
  mounted() {
    if (sessionStorage.getItem("bpath")) {
      this.isHome = sessionStorage.getItem("bpath");
    }
    if (localStorage.getItem("token")) {
      Api.getUserInfo().then((res) => {
        if (res.code == 200) { 
          this.user = res.data;
        } else if (res.code == 101) {
          localStorage.clear();
          this.$router.go();
        }
      });
    }
    this.abilityCome = sessionStorage.getItem("abilityCome");
    // --- 监听浏览器返回按钮 ---
    window.addEventListener("popstate", this.handlePopState);
  },

  methods: {
    bpath(z) {
      this.isHome = z;
    },
    /**
     * 监听浏览器返回按钮
     * @param event 
     */
    handlePopState(event) {
      this.isHome = sessionStorage.getItem("bpath");
    },
    /**
     * tabar点击事件
     */
    changeView(z) {
      this.isHome = z;
      sessionStorage.setItem("bpath", z);
      this.$emit("changeView", z);
    },
    /**
     * 处理vip到期时间
     * @param z vip到期时间
     */
    viptimeHandle(z) {
      let list = z.split(" ");
      return list[0];
    },
    /**
     * 根据类型返回会员名称
     * @param z 会员类型 
     */
    vipnameHandle(z) {
      if (z == 1) {
        return "您当前为临时会员";
      } else if (z == 2) {
        return "您当前为周卡会员";
      } else if (z == 3) {
        return "您当前为月卡会员";
      } else if (z == 4) {
        return "您当前为季卡会员";
      } else if (z == 5) {
        return "您当前为年卡会员";
      } else if (z == 6) {
        return "您当前为终身会员";
      }
    },
    /**
     * 关闭会员购买框
     * @param z 1.关闭购买框 2、3.关闭并重新获取用户信息
     */
    close(z) {
      if (z == 1) {
        this.isVipPay = false;
      } else {
        this.isVipPay = false;
        if (localStorage.getItem("token")) {
          Api.getUserInfo().then((res) => {
            console.log("拿到的用户信息", res);
            if (res.code == 200) {
              this.user = res.data;
            }
          });
        }
      }
    },
    /**
     * 获取登录返回的code
     */
    getCode() {
      if (window.top !== window.self) {
        // console.log("内嵌中");
        let a = this.$route.query;
        if (a.code) {
          this.code == a.code;
        }
        const queryParams = new URLSearchParams(window.location.search);
        if (queryParams.get("code") != null) {
          this.code = queryParams.get("code");
        }
        if (this.code != null) {
          let data = {
            code: this.code,
            login_type: 6,
          };
          Api.login(data).then((res) => {
            console.log(res);
            this.loginMessage = res.message;
            if (res.code == 200) {
              window.parent.postMessage(
                { type: "myMessage", data: JSON.stringify(res.data) },
                "*"
              );
            }
          });
        }
      } else {
        // console.log("不在内嵌");
      }
    },
    /**
     * 返回首页
     */
    back() {
      this.$router.push({ path: "/" });
    },
    // 跳转登录页
    login() {
      let path = "";
      let a = aes.endata(path);
      sessionStorage.setItem("bpath", this.isHome);
      // 获取当前页面路由的路由
      let b = this.$route.path;
      sessionStorage.setItem("fromPage", aes.endata(b));
      this.$router.push({ path: "/login" });
    },
    // 前往模型页
    nextModel() {
      this.$router.push({ path: "/ability" });
    },
    // 测试页面
    test() {
      this.$router.push({ path: "/test" });
    },
    // 个人信息框
    avatarcli() {
      this.isQuit = true;
    },
    // 移出
    quitmouseleave() {
      this.isQuit = false;
    },
    // 退出登录
    quitLogin() {
      if (this.isHome == 3 || this.isHome == 4) {
        this.changeView(1);
      }
      localStorage.removeItem("user");
      localStorage.removeItem("token");
      this.$router.go();
    },
    // 个人中心
    goPersonal(z) {
      if (z == 1) {
        if (this.user.vip_type != 6) {
          sessionStorage.setItem("origin", aes.endata("导航栏入口"));
          this.isVipPay = true;
        }
      } else if (z == 2) {
        this.isHome = 3;
        sessionStorage.setItem("bpath", 3);
        sessionStorage.setItem("origin", aes.endata("个人中心"));
        this.$emit("goPersonal", 3);
      } else if (z == 3) {
        if (this.user.vip_type != 6) {
          sessionStorage.setItem("origin", aes.endata("个人中心"));
          this.isVipPay = true;
        }
      }
    },
  },
  watch: {
    someProp(newVal, oldVal) {
      console.log("页面发生了变化", newVal);
      if (newVal == 2) {
        this.isHome = 2;
      } else if (newVal == 4) {
        this.isHome = 4;
      }
    },
    pageNum(newVal, oldVal) {
      console.log("页面出现了变化---------------,导航栏");
      if (newVal == 2) {
        this.changeView(2);
      } else if (newVal == 4) {
        this.goPersonal(1);
      }
    },
  },
  beforeDestroy() {
    return;
  },
};
</script>

<style lang="scss" scoped>
.home_header_box {
  position: fixed;
  top: 0;
  left: 0;
  z-index: 99;
}

.header::-webkit-scrollbar {
  display: none;
}

.header {
  display: flex;
  justify-content: center;
  width: 100vw;
  height: 48px;
  background-color: #ffffff;
  border-bottom: 2px solid #eeeeee;

  // background-color: #17181f;
  .box::-webkit-scrollbar {
    display: none;
  }

  .box {
    display: flex;
    position: relative;
    width: calc(100vw - 80px);
    height: 50px;
    // background-color: #17181f;
    background-color: #ffffff;

    .icon {
      display: flex;
      align-items: center;
      height: 50px;

      img {
        width: 224px;
        height: 50px;
        margin-right: 12px;
      }

      span {
        font-size: 24px;
        font-family: jiangxizhuokai, jiangxizhuokai;
        font-weight: 400;
        color: #ffffff;
        line-height: 31px;
      }
    }

    .table {
      display: flex;
      align-items: center;
      height: 50px;
      margin-left: 6.25%;
      font-size: 16px;
      font-family: MicrosoftYaHei;
      color: #000000;
      line-height: 21px;
      font-size: 16px;
      font-family: MicrosoftYaHei;
      color: #3f424d;
      line-height: 21px;

      span {
        position: relative;
        line-height: 50px;
        height: 100%;
        cursor: pointer;

        >div {
          position: absolute;
          left: 50%;
          transform: translateX(-50%);
          bottom: 0;
          width: 30px;
          height: 4px;
          background: #10a47f;
        }
      }

      span:nth-child(2) {
        margin-left: 40px;
      }
    }

    .login {
      position: absolute;
      right: 0;
      top: 5px;
      width: 100px;
      height: 40px;
      background: #10a47f;
      border-radius: 4px;
      font-size: 14px;
      font-family: MicrosoftYaHei;
      color: #ffffff;
      line-height: 40px;
      text-align: center;
      cursor: pointer;
    }

    >.no_vip {
      position: absolute;
      right: 120px;
      width: 135px;
      height: 36px;
      margin-right: 20px;
      cursor: pointer;
      top: 50%;
      transform: translateY(-50%);
    }

    .user {
      position: absolute;
      right: 40px;
      display: flex;
      align-items: center;
      height: 50px;

      .no_vip {
        width: 135px;
        height: 36px;
        margin-right: 20px;
        cursor: pointer;
      }

      span {
        font-family: MicrosoftYaHei;
        font-size: 14px;
        color: #3f424d;
        line-height: 19px;
        text-align: right;
        font-style: normal;
        margin-right: 12px;
      }

      >.avatar {
        width: 36px;
        height: 36px;
        border-radius: 18px;
      }

      .vip {
        position: absolute;
        right: -20px;
        top: 7px;
        width: 33px;
        height: 16px;
      }

      .quit {
        display: flex;
        flex-direction: column;
        align-items: center;
        position: absolute;
        border-radius: 4px;
        right: 0;
        top: 54px;
        width: 290px;
        padding: 0 0 20px 0;
        background: #ffffff;
        box-shadow: 0px 4px 24px 0px rgba(28, 31, 35, 0.04);
        border-radius: 8px;
        border: 1px solid rgba(0, 0, 0, 0.04);
        z-index: 999;

        .trans {
          width: 100%;
          height: 6px;
          margin-top: -5px;
        }

        .vip_info {
          display: flex;
          flex-direction: column;
          align-items: center;
          width: 258px;
          height: 137px;
          background: url("../../assets/images/home/home19.png");
          background-size: 100%;
          margin-top: 16px;

          >div:nth-child(1) {
            font-family: SourceHanSansCN, SourceHanSansCN;
            font-weight: 500;
            font-size: 16px;
            color: #976e4d;
            line-height: 24px;
            text-align: left;
            font-style: normal;
            margin-top: 14px;
            margin-bottom: 6px;
          }

          >div:nth-child(2) {
            font-family: SourceHanSansCN, SourceHanSansCN;
            font-weight: 400;
            font-size: 13px;
            color: #976e4d;
            line-height: 21px;
            text-align: left;
            font-style: normal;
            margin-bottom: 16px;
          }

          >div:nth-child(3) {
            width: 226px;
            height: 40px;
            background: linear-gradient(315deg, #262932 0%, #706c6f 100%);
            border-radius: 8px;
            font-family: SourceHanSansCN, SourceHanSansCN;
            font-weight: 500;
            font-size: 14px;
            color: #ffe8ce;
            line-height: 40px;
            text-align: left;
            font-style: normal;
            text-align: center;
            cursor: pointer;
          }
        }

        .vip_info_have {
          display: flex;
          width: 258px;
          height: 60px;
          background: url("../../assets/images/vip/vip26.png");
          background-size: 100%;
          margin-top: 16px;
          cursor: pointer;

          .right {
            .vip_name {
              font-family: SourceHanSansCN, SourceHanSansCN;
              font-weight: 500;
              font-size: 16px;
              color: #976e4d;
              line-height: 24px;
              text-align: left;
              font-style: normal;
              margin-top: 8px;
            }

            .vip_time {
              font-family: SourceHanSansCN, SourceHanSansCN;
              font-weight: 400;
              font-size: 12px;
              color: #cdb397;
              line-height: 18px;
              text-align: left;
              font-style: normal;
            }
          }

          .left {
            display: flex;
            align-items: center;
            width: 80px;
            height: 60px;
            background: url("../../assets/images/vip/vip27.png");
            background-size: 100%;

            img {
              width: 32px;
              height: 32px;
              margin-left: 12px;
            }
          }
        }

        .btn {
          display: flex;
          margin-top: 20px;
          justify-content: center;
          width: 258px;

          >div {
            display: flex;
            align-items: center;
            cursor: pointer;

            img {
              width: 24px;
              height: 24px;
              margin-right: 4px;
            }
          }

          .left {
            margin-right: 40px;
          }
        }
      }
    }
  }
}

// 加载的遮罩层
.mask {
  display: flex;
  align-items: center;
  justify-content: center;
  position: fixed;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  background: rgba(18, 20, 26, 0.7);
  z-index: 9999;
}
</style>
